<ng-content *ngIf="!icon" />
<ng-container *ngIf="icon">{{ icon }}</ng-container>
